// Filter values, store names and stock freshness.
import { get } from 'svelte/store';
import fetchData from '../api.js';
import UserStore from '../stores/user';

let meta = null;
const optionsCache = {};

async function fetchFilters(brands) {
	return fetchData({ action: 'agents_get_filters_data', token: get(UserStore).data, brands });
}

// store names + when stock last changed; loaded once per session
export async function loadCatalogMeta() {
	if (meta) return meta;
	const res = await fetchFilters([]);
	const stores = {};
	for (const s of (res && res.stores) || []) stores[String(s.store)] = s.name;
	meta = { stores, stockMinutesAgo: res ? res.stock_minutes_ago : null };
	optionsCache[''] = (res && res.data) || {};
	return meta;
}

// filter values that are in stock for the chosen brands ([] = all brands)
export async function loadFilterOptions(brands = []) {
	const key = [...brands].sort().join('|');
	if (!optionsCache[key]) {
		const res = await fetchFilters(brands);
		if (!res) return {};
		optionsCache[key] = res.data || {};
	}
	return optionsCache[key];
}

export function storeName(stores, id) {
	return (stores && stores[String(id)]) || `חנות ${id}`;
}
